import { addContact, setHomeData } from '@/actions/home';
import { CountryCodeSelector } from '@/helpers/CountryCodeSelector';
import { blockInvalidChar } from '@/helpers/formDataHelper';
import { Button, notification } from 'antd';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

const RequestCallForm = ({ onSuccess }) => {
  const dispatch = useDispatch();
  const initialData = {
    first_name: '',
    last_name: '',
    email: '',
    phone_number: '',
    subject: '',
    message: '',
    campaign: [],
    country: '',
    city: '',
    country_code: '+977',
  };
  const status = useSelector((state: any) => state?.home?.contact?.status);

  const [data, setData] = useState(initialData);
  useEffect(() => {
    if (status) {
      onSuccess();
      notification.success({
        message: 'Thank you! Request successfully submitted.',
      });
      setTimeout(
        () =>
          dispatch(setHomeData({ name: 'contact', key: 'status', value: false })),
        2000
      );
    }
  }, [status]);

  const handleSubmit = (e) => {
    e.preventDefault();
    const newData = {
      first_name: data?.first_name,
      last_name: data?.last_name,
      email: data?.email,
      subject: 'Request Call',
      message: 'Request Call',
      phone_number: `${data?.country_code}-${data?.phone_number}`,
    };
    dispatch(addContact(newData));
    setData(initialData);
  };

  return (
    <form id="callbackForm" onSubmit={handleSubmit}>
      <div className="form-row">
        <div className=" col-lg-6 col-md-12">
          <div className="form-group">
            <input
              value={data.first_name}
              onChange={(e) => setData({ ...data, first_name: e.target.value })}
              type="text"
              className="form-control w-100"
              placeholder="First Name"
              required
            />
          </div>
        </div>
        <div className="col-lg-6 col-md-12">
          <div className="form-group">
            <input
              value={data.last_name}
              onChange={(e) => setData({ ...data, last_name: e.target.value })}
              type="text"
              className="form-control w-100"
              placeholder="Last Name"
              required
            />
          </div>
        </div>
      </div>

      <div className="form-row">
        <div className="col-lg-12 col-md-12">
          <div className="form-group">
            <input
              type="email"
              value={data.email}
              onChange={(e) => setData({ ...data, email: e.target.value })}
              className="form-control w-100"
              placeholder="Email"
              required
            />
          </div>
        </div>
      </div>
      <div className="form-row">
        <div className="col-lg-4 col-md-12 mb-2">
          <CountryCodeSelector
            onChange={(val) => {
              setData({ ...data, country_code: val });
            }}
            defaultValue={'+977'}
          />
        </div>
        <div className="col-lg-8 col-md-12">
          <div className="form-group">
            <input
              type="number"
              value={data.phone_number}
              onChange={(e) => setData({ ...data, phone_number: e.target.value })}
              className="form-control w-100"
              placeholder="Phone Number"
              required
              onKeyDown={blockInvalidChar}
            />
          </div>
        </div>
      </div>
      <div className="contact-send-btn text-center">
        <Button
          className="btn-secondary border-danger"
          size="large"
          htmlType="submit"
        >
          Submit
        </Button>
      </div>
    </form>
  );
};

export default RequestCallForm;
